
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Cluster-Kopfschmerzen gehören zu den trigeminoautonomen Kopfschmerzen. Unter
diesem Zungenbrecher werden fünf Kopfschmerzsyndrome zusammengefasst, wobei die
Cluster-Kopfschmerzen das bekannteste sind. Gemeinsam sind diesen Kopfschmerzen
die (meist) kurz dauernden, heftigen Schmerzattacken und die Begleitsymptome:
Tränenfluss, gerötete Augen, geschwollene Augenlider, eine laufende, verstopfte
Nase und gerötete Haut an der Stelle des Schmerzes. Der Cluster-Kopfschmerz
äussert sich mit streng einseitigen, sehr starken Attacken im Bereich der Augen.
Diese können zwischen 15 Minuten und 3 Stunden dauern.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;